export default __webpack_public_path__ + "static/media/474.c55ddaf4.jpg";